module.exports = __webpack_public_path__ + "img/success.96690c16.png";